<template>
  <div>
    <div>
      <div>
        <h1 class="mr-sm-4 header-tablepage">{{ pageDetail.name }}</h1>
      </div>

      <div class="title-tabs mt-3 d-flex align-items-center">
        {{ pageDetail.header }}
        <div class="ml-auto">
          <InputSelectLanguage ref="inputLang" @changeLang="changeLanguage" />
        </div>
      </div>
      <div v-if="isLoading">
        <OtherLoading />
      </div>
      <template v-else>
        <div class="bg-white p-3">
          <b-row class="align-items-center row-gap-lg">
            <b-col cols="2" class="text-center"> Sort Order</b-col>
            <b-col cols="2"> </b-col>
            <b-col cols="2">Display Name </b-col>
            <b-col cols="4" class="text-center"> Description</b-col>
            <b-col cols="1"> </b-col>
            <b-col cols="1" class="text-center"> Default</b-col>
            <template v-for="(field, index) of list">
              <b-col cols="2" :key="'sort-order' + field.id + '-' + index">
                <div class="content-between">
                  <font-awesome-icon
                    icon="chevron-circle-up"
                    class="icon-size"
                    @click="switchProfileIndex(field, index, false)"
                  />
                  {{ index + 1 }}
                  <font-awesome-icon
                    icon="chevron-circle-down"
                    :class="`icon-size`"
                    @click="switchProfileIndex(field, index, true)"
                  />
                </div>
              </b-col>
              <b-col cols="2" :key="'name' + field.id + '-' + index">
                <InputText
                  type="text"
                  placeholder=""
                  :disabled="!field.isAddNew"
                  class="mb-0"
                  :v="$v.list.name"
                  :isValidate="$v.list.$each.$iter[index].name.$error"
                  v-model="field.name"
              /></b-col>
              <b-col cols="2" :key="'display-name' + field.id + '-' + index">
                <InputText
                  type="text"
                  placeholder="Display Name"
                  class="mb-0"
                  v-model="field.field_choice_language[languageIndex].name"
              /></b-col>
              <b-col cols="4" :key="'desc' + field.id + '-' + index">
                <InputText
                  type="text"
                  placeholder=""
                  class="mb-0"
                  v-show="field.choice_type_id == 3"
                  v-model="field.description"
                />
              </b-col>
              <b-col cols="1" :key="'trash-' + field.id + '-' + index">
                <font-awesome-icon
                  icon="trash-alt"
                  class="cursor-pointer"
                  v-if="field.isAddNew || field.is_no_update == 0"
                  @click="deleteField(index)"
              /></b-col>
              <b-col
                cols="1"
                :key="'check-box-' + field.id + '-' + index"
                class="text-center"
              >
                <b-form-checkbox
                  class="disableCheckbox"
                  :id="`checkbox-profile-${index}`"
                  :name="`checkbox-profile-${index}`"
                  v-model="field.isDefault"
                  :value="1"
                  :unchecked-value="0"
                  @change="handleDefaultChange($event, index)"
                >
                </b-form-checkbox>
              </b-col>
            </template>
            <b-col cols="2" class="text-center"> </b-col>
            <b-col cols="6" lg="5" xl="4" class="d-inline-flex">
              <b-button variant="custom-link mr-auto" @click="addField(1)"
                >Add Choice</b-button
              >
              <b-button
                variant="custom-link ml-auto"
                @click="addField(3)"
                v-if="list.filter((el) => el.choice_type_id == 3).length == 0"
                >Add Other Field</b-button
              >
            </b-col>
            <b-col cols="4"> </b-col>
            <b-col cols="1"> </b-col>
            <b-col cols="1"> </b-col>
          </b-row>
        </div>
      </template>

      <FooterAction @submit="submit()" routePath="/setting/personal" />
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import OtherLoading from "@/components/loading/OtherLoading";
import DataType from "./type.js";
import InputSelectLanguage from "@/components/inputs/InputSelectLanguage";
export default {
  components: { OtherLoading, InputSelectLanguage },
  meta: { label: "custom-label" },
  validations() {
    return {
      list: {
        $each: {
          name: {
            required,
          },
        },
      },
    };
  },

  data() {
    return {
      list: [],
      listDelete: [],
      updateList: [],
      isLoading: true,
      pageDetail: {
        name: "",
        header: "",
        updated: "",
      },
      isDefault: null,
      languageList: [],
      languageIndex: 0,
    };
  },
  async created() {
    const page = DataType.find((el) => el.id == this.$route.params.id);
    this.pageDetail = page;
  },
  destroyed() {},
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      this.isLoading = true;
      const res = await this.axios(
        `setting/GetFieldChoiceFromId/${this.$route.params.id}`
      );

      if (res.data.detail.field_choices[0].field_choice_language.length == 0) {
        for (const element of this.$refs.inputLang.languageList) {
          for (const field of res.data.detail.field_choices) {
            const label = {
              id: 0,
              language_id: element.id,
              field_choice_id: field.id,
              name: field.name,
            };
            field.field_choice_language.push(label);
          }
        }
      }
      this.isDefault = res.data.detail.field_choices.filter(
        (el) => el.isDefault == 1
      );
      this.list = res.data.detail.field_choices.sort(
        (a, b) => a.sort_order - b.sort_order
      );
      this.isLoading = false;
    },
    addField(type) {
      this.list.push({
        id: 0,
        register_form_field_id: 0,
        field_id: 2,
        name: type == 1 ? `Choice ${this.list.length + 1}` : "อื่นๆ",
        sort_order: this.list.length,
        description: "โปรดระบุ",
        is_display: 1,
        choice_type_id: type,
        is_child: 0,
        isDefault: 0,
        reference_id: 0,
        zip_code: 0,
        is_update: 0,
        is_no_update: 0,
        denpendent: [],
        isAddNew: true,
      });
    },
    deleteField(index) {
      const dele = this.list.splice(index, 1);
      this.listDelete.push(dele[0]);
    },
    async submit() {
      try {
        this.$v.list.$touch();
        if (this.$v.list.$error) return;
        this.$bus.$emit("showLoading");

        const res = await this.axios.post(
          `setting/${this.pageDetail.updated}`,
          {
            field_choices: this.list,
            delete_field_choices: this.listDelete,
          }
        );
        this.getList();
        this.$bus.$emit("hideLoading");
        if (res.data.result == 1)
          this.successAlert().then(() => {
            this.$router.push("/setting");
          });
        else this.errorAlert();
      } catch (error) {
        this.errorAlert(error.message);
        this.$bus.$emit("hideLoading");
      }
    },
    async switchProfileIndex(items, index, val) {
      if (index == 0 && !val) {
        return;
      }

      this.list.splice(index, 1);
      index = val ? index + 1 : index - 1;

      this.list.splice(index, 0, items);
      var index = 0;
      for (const fields of this.list) {
        fields.sort_order = index;
        index++;
      }
      this.$nextTick(() => {
        this.list = [...this.list];
        // this.sortArray();
      });
    },
    handleDefaultChange(val, index) {
      this.$nextTick(
        () =>
          (this.list = [
            ...this.list.map((el, i) => {
              if (i == index) return el;
              return { ...el, isDefault: 0 };
            }),
          ])
      );
    },

    changeLanguage(val) {
      let index = this.list[0].field_choice_language.findIndex(
        (el) => el.language_id == val
      );
      if (index != -1) return (this.languageIndex = index);
      let langList = this.$refs.inputLang.languageList;
      for (const list of this.list) {
        if (list.field_choice_language.length != langList.length) {
          list.field_choice_language = [
            ...list.field_choice_language,
            ...langList
              .filter((el) =>
                list.field_choice_language.find((a) => a.language_id != el.id)
              )
              .map((el) => {
                return {
                  id: 0,
                  language_id: el.id,
                  field_choice_id: list.id,
                  name: "",
                };
              }),
          ];
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-size {
  font-size: 20px;
  color: #575757;
  cursor: pointer;
}
</style>
